import { SINGLE_PHOTOGRAPHER_FETCH_REQUEST, SINGLE_PHOTOGRAPHER_FETCH_SUCCESS, SINGLE_PHOTOGRAPHER_FETCH_FAILURE } from './types';
import { fetchDaysSuccess } from '../Days/action';
import { fetchHoursSuccess } from '../Hours/action';
import baseUrl from '../url'

const fetchSinglePhotographerRequest = () => {
    return {
        type: SINGLE_PHOTOGRAPHER_FETCH_REQUEST
    }
}

const fetchSinglePhotographerSuccess = photographer => {
    return {
        type: SINGLE_PHOTOGRAPHER_FETCH_SUCCESS,
        payload: photographer,
    }
}

const fetchSinglePhotographerFailure = error => {
    return {
        type: SINGLE_PHOTOGRAPHER_FETCH_FAILURE,
        payload: error,
    }
}

export const getSinglePhotographer = (photographer) => {
    if (photographer) {
        return (dispatch) => {
            dispatch(fetchSinglePhotographerRequest());
            fetch(`${baseUrl}/photographers/${photographer}`, {
                    method: 'GET'
                })
                .then(response => response.json())
                .then((response) => {
                    dispatch(fetchSinglePhotographerSuccess(response));
                })
                .catch((error) => {
                    dispatch(fetchSinglePhotographerFailure(error.message));
                })
        }
    } else {
        return (dispatch) => {
            dispatch(fetchSinglePhotographerSuccess({}));
            // dispatch(fetchDaysSuccess([]));
            // dispatch(fetchHoursSuccess({}));
        }
    }
}